const PMCompanyConfig = {
    1: {
        "defaultLanguage": "EN",
        "country": "INDIA",
        "currency": "INR",
        "pinCodeLength": 6,
        "isHSNVisible": true,
        "HSNEntryAllowed": true,
        "prefStockBranchId": 12,
        "prefStockGSTINCode": "27AADCI9794D1Z6",
        "defaultStateId": 9,
        "defaultPMBranchId": 1,
        "GSTRates":  [0, 3, 5, 12, 18, 28],
        "phoneNumberLength": [10],
        "isGSTINFetchAutomated": true,
        "isBillingAddressFetchAutomated": true,
        "isTDSAutomated": true,
        "GSTINLabel": "GSTIN",
        "GSTRateLabel": 'GSTRate',
        "MSMEDLabel": 'MSMED',
        "isEInvoiceRequired": true,
        "hasSingleTaxSystem": false,
        "isInternational": false,
        "currencyShortName": 'Rs',
        "currencySymbol": '₹',
        "portalLink":  "https://portal.procmart.com",
        "numberLocale": "en-IN",
        "bankAccountCode": 'IFSC Code',
        "canApplyTds194Q": true,
        "isPOMailSentRequiredForFollowUp": true,
        "isSellerEInvoiceApplicable": false,
        "maxCashAllowedVPAmount": 10000,
        "paymentTrackerUsed": false,
        "autoSkipPIVerification": false,
        "quotationApprovalTypeIds": [1, 2, 3, 4, 5, 6, 10, 28, 38, 39, 40],
        "buyerPOApprovalTypeIds": [14, 22, 26, 30],
        "sellerPOApprovalTypeIds": [9, 16, 17, 31, 32, 33, 34, 35, 37, 41, 42, 44],
        "expenseSellerPOApprovalTypeIds": [9, 20, 21, 34, 35],
        "companyApprovalTypeIds": [18, 19, 25, 27, 43],
        "companyBankApprovalTypeIds": [23],
        "materialMasterPartialSpecsApprovalTypeIds": [15],
        "CNDNApprovalTypeIds": [8, 12],
        "PIPunchApprovalTypeIds": [11],
        "branchPaymentTermsApprovalTypeIds": [13],
        "isPostRequirementTransactionsEnabled": true,
        "isMSMEDApplicable": true
    },
    2: {
        "defaultLanguage": "ID",
        "country": "INDONESIA",
        "currency": "IDR",
        "pinCodeLength": 5,
        "isHSNVisible": false,
        "HSNEntryAllowed": false,
        "prefStockBranchId": 1,
        "prefStockGSTINCode": "400440137017000",
        "defaultHSNCode": 99999999,
        "defaultGSTRate": 11,
        "defaultPMBranchId": 19875,
        "GSTRates":  [11, 12],
        "phoneNumberLength": [8, 9, 10, 11, 12],
        "defaultStateId": 96,
        "defaultCountryId": 102,
        "defaultSupplyType": "B2B",
        "isTDSAutomated": false,
        "GSTINLabel": "NPWP",
        "GSTRateLabel": 'TaxRate',
        "MSMEDLabel": 'MSMED',
        "isEInvoiceRequired": false,
        "hasSingleTaxSystem": true,
        "isInternational": true,
        "currencyShortName": 'Rp',
        "currencySymbol": 'Rp',
        "portalLink":  "https://intl.procmart.com",
        "numberLocale": "en-US",
        "bankAccountCode": 'IFSC Code',
        "canApplyTds194Q": false,
        "isPOMailSentRequiredForFollowUp": false,
        "isSellerEInvoiceApplicable": true,
        "maxCashAllowedVPAmount": 500000,
        "paymentTrackerUsed": true,
        "autoSkipPIVerification": true,
        "quotationApprovalTypeIds": [1, 2, 3, 4, 5, 6, 10, 28, 38, 39, 40],
        "buyerPOApprovalTypeIds": [14, 22, 26, 30],
        "sellerPOApprovalTypeIds": [9, 16, 17, 31, 32, 33, 34, 35, 37, 41, 42, 44],
        "expenseSellerPOApprovalTypeIds": [9, 20, 21, 34, 35],
        "companyApprovalTypeIds": [18, 19, 25, 27, 43],
        "companyBankApprovalTypeIds": [23],
        "materialMasterPartialSpecsApprovalTypeIds": [15],
        "CNDNApprovalTypeIds": [8, 12],
        "PIPunchApprovalTypeIds": [11],
        "branchPaymentTermsApprovalTypeIds": [13],
        "isPostRequirementTransactionsEnabled": false,
        "isIndonesiaVPDownload" : true,
        "isMSMEDApplicable": false
    },
    3: {
        "defaultLanguage": "MY",
        "country": "MALAYASIA",
        "currency": "MYR",
        "pinCodeLength": 5,
        "isHSNVisible": false,
        "HSNEntryAllowed": false,
        "prefStockBranchId": 197,
        "prefStockGSTINCode": "",
        "defaultPMBranchId": 197,
        "GSTRates":  [11],
        "phoneNumberLength": [8, 9, 10, 11, 12],
        "defaultHSNCode": 99999998,
        "defaultGSTRate": 11,
        "defaultStateId": 98,
        "defaultCountryId": 132,
        "defaultSupplyType": "B2B",
        "isTDSAutomated": false,
        "GSTINLabel": "NPWP",
        "GSTRateLabel": 'TaxRate',
        "MSMEDLabel": 'SSM Registration',
        "isEInvoiceRequired": false,
        "hasSingleTaxSystem": true,
        "isInternational": true,
        "currencyShortName": 'MYR',
        "currencySymbol": 'RM',
        "portalLink":  "https://intl.procmart.com",
        "numberLocale": "en-US",
        "bankAccountCode": 'IFSC Code',
        "canApplyTds194Q": false,
        "isPOMailSentRequiredForFollowUp": true,
        "isSellerEInvoiceApplicable": false,
        "maxCashAllowedVPAmount": 10000,
        "paymentTrackerUsed": false,
        "autoSkipPIVerification": true,
        "quotationApprovalTypeIds": [1, 2, 3, 4, 5, 6, 10, 28, 38, 39, 40],
        "buyerPOApprovalTypeIds": [14, 22, 26, 30],
        "sellerPOApprovalTypeIds": [9, 16, 17, 31, 32, 33, 34, 35, 37, 41, 42, 44],
        "expenseSellerPOApprovalTypeIds": [9, 20, 21, 34, 35],
        "companyApprovalTypeIds": [18, 19, 25, 27, 43],
        "companyBankApprovalTypeIds": [23],
        "materialMasterPartialSpecsApprovalTypeIds": [15],
        "CNDNApprovalTypeIds": [8, 12],
        "PIPunchApprovalTypeIds": [11],
        "branchPaymentTermsApprovalTypeIds": [13],
        "isPostRequirementTransactionsEnabled": false,
        "isMSMEDApplicable": false
    },
    4: {
        "defaultLanguage": "VN",
        "country": "VIETNAM",
        "currency": "VND",
        "pinCodeLength": 5,
        "isHSNVisible": false,
        "HSNEntryAllowed": false,
        "prefStockBranchId": 1,
        "prefStockGSTINCode": "",
        "defaultPMBranchId": 1,
        "GSTRates":  [11],
        "phoneNumberLength": [8, 9, 10, 11, 12],
        "defaultHSNCode": 99999999,
        "defaultGSTRate": 11,
        "defaultStateId": 96,
        "defaultCountryId": 102,
        "defaultSupplyType": "B2B",
        "isTDSAutomated": false,
        "GSTINLabel": "NPWP",
        "GSTRateLabel": 'TaxRate',
        "MSMEDLabel": 'MSMED',
        "isEInvoiceRequired": false,
        "hasSingleTaxSystem": true,
        "isInternational": true,
        "currencyShortName": 'Rp',
        "currencySymbol": 'Rp',
        "portalLink":  "https://intl.procmart.com", 
        "numberLocale": "en-US",
        "bankAccountCode": 'IFSC Code',
        "canApplyTds194Q": false,
        "isPOMailSentRequiredForFollowUp": true,
        "isSellerEInvoiceApplicable": false,
        "maxCashAllowedVPAmount": 10000,
        "paymentTrackerUsed": false,
        "autoSkipPIVerification": true,
        "quotationApprovalTypeIds": [1, 2, 3, 4, 5, 6, 10, 28, 38, 39, 40],
        "buyerPOApprovalTypeIds": [14, 22, 26, 30],
        "sellerPOApprovalTypeIds": [9, 16, 17, 31, 32, 33, 34, 35, 37, 41, 42, 44],
        "expenseSellerPOApprovalTypeIds": [9, 20, 21, 34, 35],
        "companyApprovalTypeIds": [18, 19, 25, 27, 43],
        "companyBankApprovalTypeIds": [23],
        "materialMasterPartialSpecsApprovalTypeIds": [15],
        "CNDNApprovalTypeIds": [8, 12],
        "PIPunchApprovalTypeIds": [11],
        "branchPaymentTermsApprovalTypeIds": [13],
        "isPostRequirementTransactionsEnabled": false,
        "isMSMEDApplicable": false
    }
}

export const getPMCompanyConfig = (companyId) => {
    if(companyId === "ALL"){
        return PMCompanyConfig
    }
    if(companyId){
        return PMCompanyConfig[companyId]
    } else {
        return PMCompanyConfig[1]
    }
}